import React, { Component } from 'react';
import SelectLanguage from "../../../../listing/components/SelectLanguage";
import { connect } from "react-redux"
import { isKioskMode } from "../../../selectors/ui";
import { isDynamicListing } from '@checkout-b/checkout/selectors/dynamic-listing';
import { TICKETS_DISPLAY_LIST } from '@checkout-b/checkout/reducers/ui';

class InventoryContentContainer extends Component {
    render() {
        return(
            <div className="tickets__content">
                {!this.props.isKiosk
                    && !this.props?.isDynamic
                    && this.props.uiConfig.listings?.ticketsDisplayType !== TICKETS_DISPLAY_LIST
                    && (<SelectLanguage className='select-language--checkout'/>)}
                <div className={!this.props.isKiosk ? 'tickets__content__list' : ''}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
    isKiosk: isKioskMode(state),
    isDynamic: isDynamicListing(state),
    uiConfig: state.ui.uiConfig,
  }
}


export default connect(mapStateToProps)(InventoryContentContainer);
